import * as React from 'react';

//import Grid from '@mui/material/Grid';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';

import { logo } from '../themes/defaultTheme';
import Image from 'mui-image';


import {useForm, FormProvider} from 'react-hook-form';
import SponsorFooter from '../components/SponsorFooter';
import Form from '../components/form/Form';
import FormTextField from '../components/form/FormTextField';
import FormButton from '../components/form/FormButton';

export default function OtpPage() {

  const methods = useForm({ defaultValues: { email: '', token: '' } });

  const onSubmit = async(data)=>{
    console.log(data);
  }

  return (
      <Container component="main" maxWidth="xs">
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Image src={logo} width={128} />

          <Typography component="h1" variant="h5">
            One Time Password
          </Typography>
          <FormProvider {...methods}>
            <Form onSubmit={methods.handleSubmit(onSubmit)}>
                <Grid container spacing={2}>
                    <Grid xs={12}>
                      <FormTextField name="email" label="Email" required autoComplete="email" autoFocus />
                    </Grid>
                    <Grid xs={12}>
                      <FormTextField name="token" label="Token" required autoFocus rules={{maxLength: {value: 6, message: "Too Long!"}, minLength: {value: 6, message: "Too Short"}}} />
                    </Grid>
                    <Grid xs={12}>
                      <FormButton fullWidth>Sign In</FormButton>
                    </Grid>
                  </Grid>
            </Form>
          </FormProvider>
          <SponsorFooter />
        </Box>
      </Container>
  );
}